export default __webpack_public_path__ + "static/media/valmir.2985c1a6.png";